import moment from 'moment'

export default function calculateHoursFromStartAndEndTime(
  startTime: string,
  endTime: string,
  breakHours: number,
): number {
  const timeDifference = moment(endTime, 'HH:mm').diff(moment(startTime, 'HH:mm'), 'hours', true)

  return Number(timeDifference) - breakHours
}
